var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H4C1.79086 0 0 1.79086 0 4V12H8C10.2091 12 12 10.2091 12 8V0Z",
    fill: "#FCD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderM);
export default __webpack_public_path__ + "static/media/border-m.356b8ce4e9088c5096b24f46c1eb7867.svg";
export { ForwardRef as ReactComponent };